// GuideCardAtom.tsx
import React from "react";

// ASSETS

// STYLES
import {
  CardWrapper,
  TitleWrapper,
  Antet,
} from "./AuthorisationGuideCardAtomStyled";

// LIBRARIES
import Skeleton from "react-loading-skeleton";

// MISC
import { ICardProps } from "./AuthorisationGuideCardAtomModel";
import { TextType } from "../CustomText/CustomTextModel";
import { COLORS, SIZE } from "../../../constants/variables";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "../CustomText/CustomText";
import { useNavigate } from "react-router-dom";

const AuthorisationGuideCardAtom = (props: ICardProps) => {
  // PROPERTIES
  const { title = "", documentType = "", pdfUrl = "" } = props;

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const navigate = useNavigate();
  // STATE CONSTANTS
  const isLoading: boolean = !title || !documentType;

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const handleDownload = async () => {
    if (documentType === "Ghid") {
      window.open(pdfUrl, "_blank");
    } else {
      try {
        const response = await fetch(pdfUrl);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = pdfUrl.split("/").pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Download error:", error);
      }
    }
  };

  return (
    <>
      {!isLoading ? (
        <CardWrapper biggerCursor={biggerCursor} onClick={handleDownload}>
          <Antet>
            <CustomText
              text={documentType}
              type={TextType.H5bold}
              color={COLORS.VividAuburn}
            />
          </Antet>
          <TitleWrapper documentType={documentType}>
            <CustomText
              text={title}
              type={TextType.H4}
              color={COLORS.RaisinBlack}
            />
          </TitleWrapper>
        </CardWrapper>
      ) : (
        <CardWrapper>
          <Skeleton height={SIZE.max24} width={120} />
          <Skeleton height={SIZE.max78} width={120} />
        </CardWrapper>
      )}
    </>
  );
};

export default AuthorisationGuideCardAtom;
